module.exports = __webpack_public_path__ + "media/src/assets/images/lps-buy_housing-a66253370961bd75e23ea35ee0b675e3.png";